import { OrderService } from './../orders.service';
import { Component, OnInit } from '@angular/core';
import { Order } from '../order.model';
import { Router } from '@angular/router';

@Component({
  selector: 'ng-order-items',
  templateUrl: 'order-items.component.html'
})

export class OrderItemsComponent implements OnInit {

  public order:Order;

  constructor(public ordersServ:OrderService,public router:Router) {
    this.order=new Order();
  }

  ngOnInit() {
    this.ordersServ.getObject('order').subscribe(order=>this.order=order)
  }


  tableProprieties(): string[] {

    const columns= [
      'producto',
      'qtd',
      'preço'
    ];

    // if(!this.isAdminOrUserKhuzela()) {
    //   columns.splice(2,1)
    // }

    return columns;
  }

}
